export default __webpack_public_path__ + "static/media/circle-value.015c9c68.svg";